<template>
    
    <div class="m_bottom_area" ref="m_bottom_area">
       
        <div class="item" v-for="(item,index) in middleItems" :key="index" @click="routerPush(item,middleItems)" 
         :style="styleObj">
            <div class="item_content">
                <img :src="base_url().img_baseurl+item.ChapterThemeImg.visitimg" alt="">
                <div class="text">{{item.name}}</div>
            </div>
        </div>
        <span class="clearfix"></span> 
    </div>
</template>

<script>
    export default {
        name:"mBottomArea",
        props: {
            middleItems:Array,
            bottomAreaStyle:Object
        },
        data(){
            return {
                m_bottom_area_item_height:'',
                m_bottom_area_item_width:'',
                styleObj:{
                    background:'',
                    color:'',
                    width:'',
                    height:''
                },
                $version:0
            }
        },
        created(){
            this.$version = this.$version;
        },
        mounted(){
            this.m_bottom_area_item_width = (this.$refs.m_bottom_area.offsetWidth/3 - 3)+"px";
            this.m_bottom_area_item_height = ((this.$refs.m_bottom_area.offsetWidth/3 - 3)*0.9)+"px";
        },
        beforeUpdate(){
            this.styleObj.background = this.middleItems[0].normalStyle.background;
            this.styleObj.color = this.middleItems[0].normalStyle.color;
            this.styleObj.width =  this.m_bottom_area_item_width;
            this.styleObj.height = this.m_bottom_area_item_height;
        },
        methods:{
             routerPush(item,chapterList){
                //获取子章节页
                this.pathInfo.parentChapterLists.push(chapterList);
                if(item.ishaschildren){
                   //进入子章节页
                    this.$router.push({path: '/SubChapter', query: {id: item.id,name:item.name}});
                    this.getSubChapterData(item.id);
                }else{
                    this.$router.push({path:'/Content',query: {id: item.id,name:item.name}});
                }
               
                // 设置页面title
                // document.getElementById('titleId').innerHTML = item.name+" - "+this.globleTitle;
                this.setGlobleTitle(item.name + " - " + this.globleTitle);
                //存储章节列表，便于内容页匹配标题
                window.sessionStorage.setItem('parentChapterLists',JSON.stringify( this.pathInfo.parentChapterLists));
            },
            //获取子章节内容
            getSubChapterData(chapterId){
                this.$emit('getSubChapter',chapterId);
            }
        }
    }
</script>

<style  scoped>
    @media screen and (min-width:768px){
        .m_bottom_area{
            display:none;
        }
    }
    @media screen and (max-width:768px){
        .m_bottom_area{
            position: relative;
            width: 90%;
            left: 5%;
            bottom: 0;
            text-align:center;
        }
        .m_bottom_area .item{
            position:relative;
            float: left;
            border: solid 1px #fff;
            background: rosybrown;
        }
        .m_bottom_area .item .item_content{
            position: absolute;
            width: 100%;
            top:50%;
            transform: translate3d(0,-50%,0);
            left: 0;
            right: 0;
            margin: auto;
            text-align: center;
        }
        .m_bottom_area .item .item_content img{
            max-width: 30%;
            max-height: 70%;
        }
        .m_bottom_area .item .item_content .iconfont{
            position: relative;
            font-size: 30px;
           
        }
        .m_bottom_area .item .item_content .text{
            position: relative;
            width: 80%;
            margin: 0 auto;
            
            font-size: 12px;
        }
    }
</style>